import { render, staticRenderFns } from "./BookmarkMenu.vue?vue&type=template&id=d8a10d4a&scoped=true"
import script from "./BookmarkMenu.vue?vue&type=script&lang=js"
export * from "./BookmarkMenu.vue?vue&type=script&lang=js"
import style0 from "./BookmarkMenu.vue?vue&type=style&index=0&id=d8a10d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a10d4a",
  null
  
)

export default component.exports